import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useLocation, useParams } from "react-router-dom";
import {Helmet} from "react-helmet";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { MdOutlineSettingsInputComponent, MdOutlineArrowLeft } from "react-icons/md";

import Main from "./Main";
import { AppContext } from "../../Context";
import { Config } from "../../inc/Config";
import { Loader, FetchAsync, GET, permissions } from "../../inc/Fetch";
import { Img } from "../../components/Elements";
import BooksList from "./components/BooksList";
import Permission from "../Permission";
import Filter from "../../components/Filter";

import './css/books.css'

export default function Books() {

    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();

    // let site = data?.cats?.filter(r => r?.name == params?.id);
    // site = site?.length ? site[0] : {};

    const { userData, siteData } = useContext(AppContext); 
    const [site, setsite] = siteData;
    const [userinfo, setuserinfo] = userData;
    
    const [filterOpen, setfilterOpen] = useState(false);
    const [filter, setfilter] = useState({});
    const [names, setnames] = useState([]);

    let catID = site?.cats?.filter(r => r?.name == params?.id);
    catID = catID?.length ? catID[0]?._id : false;
    
    async function loadData() {
        let res = await FetchAsync(`books/view`, { cat: catID, filter:filter });
        return res;
    }

    const { data, error, isLoading, refetch } = useQuery("books", loadData); 
    
    function searchForm(e) {
        e.preventDefault();
        refetch();
        setfilterOpen(false);
    }
    

    if (isLoading) {
        return <Loader />
    }

    if (data?.error == "login") {
        return false;
    }



    if (!userinfo?._id) {
        return <Permission />
    } else {
        
        let perms = permissions(userinfo, false, catID, "books");
        if (!perms) {
            return <Permission />
        }
        
    }


	return (
		<>

        <Filter Open={filterOpen} setOpen={setfilterOpen}>
            <form onSubmit={searchForm} className='filterFormBox'>
                <div style={{flex:1}}>
                    <label>
                        <span>{t("keywords")}</span>
                        <input type='search' 
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                text:d?.target?.value,
                            }))}
                            value={filter?.text}
                            placeholder={`${t("search")}..`} 
                        />
                    </label>

                    <label>
                        <span>{t("classes")}</span>
                        <select
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                classes:d?.target?.value,
                            }))}
                        >
                            <option value="">--</option>
                            {Object.entries(global.Classes)?.map((v, k) => {

                                return (
                                    <option key={k} value={v[0]}>{t("class")} {v[1]}</option>
                                );

                            })}
                            
                        </select>
                    </label>

                    <label>
                        <span>{t("book")}</span>
                        <select
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                names:d?.target?.value,
                            }))}
                        >
                            <option value="">--</option>
                            {data?.book_name?.map((v, k) => {

                                return (
                                    <option key={k} value={v?._id}>{v?.name}</option>
                                );

                            })}
                            
                        </select>
                    </label>

                    <label>
                        <span>{t("part")}</span>
                        <select
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                part:d?.target?.value,
                            }))}
                        >
                            <option value="">--</option>
                            {[...Array(4)]?.map((v, k) => {
        
                                return (
                                    <option key={k} value={k + 1}>{t("part")} {k + 1}</option>
                                );

                            })}
                            
                        </select>
                    </label>

                </div>
                <button className='btn'>{t("start_searching")}</button>
            </form>
        </Filter>

        <Main>

            <div style={{ paddingTop:155 }}  className="mainWidth">
                <nav className='breadcrumbs'>
                    <Link to={`/site/${params?.id}`}>{t("home")}</Link>
                    <MdOutlineArrowLeft />
                    <Link>{t("books_title")}</Link>
                
                </nav>
            </div>

            <div className='section4'>

                <div className="mainWidth">
                    
                    <div style={{marginTop:20}} className='mainSectionBox inside'>
                        <div>
                            <h1>{t("books_title")}</h1>
                            <hr />
                        </div>

                        <div style={{display:"flex", gap:5}}>
                            <Link onClick={() => setfilterOpen(r => !r)} title={t("filter")} className='btn openFilter'><MdOutlineSettingsInputComponent /></Link>
                        </div>

                    </div>

                    
                    <div className='audioListBox'>
                        {data?.books?.map((v, k) => {
                            return(
                                <BooksList v={v} key={k}/>
                            )
                        })}

                    </div>
                </div>
            </div>

         
        </Main>

		</>
	)
}
